import { CHECKOUT_EVENTS } from '../constants/angular-events';
import { isEmpty } from 'lodash-es'
import { isSupportPaymentMethod } from '@payment/payment-sdk'

app.directive("checkoutCartForm", [
  '$http'
  '$timeout'
  '$compile'
  'checkoutService'
  'cartService'
  'mainConfig'
  '$rootScope'
  'logger'
  'storePickupOptions'
  'storePickupConfig'
  'storePickupAddresses'
  '$injector'
  (
    $http
    $timeout
    $compile
    checkoutService
    cartService
    mainConfig
    $rootScope
    logger
    storePickupOptions
    storePickupConfig
    storePickupAddresses
    $injector
  ) ->
    {
      restrict: 'A'
      link: (scope, element, attrs) ->
        onCartFormLoaded = (() -> scope.$emit(CHECKOUT_EVENTS.CART.FORM.LOADED))
        scope.zeekPickupStatus = {}
        scope.storePickupOptions = storePickupOptions
        scope.storePickupConfig = storePickupConfig
        scope.storePickupAddresses = storePickupAddresses

        scope.$on CHECKOUT_EVENTS.CART.FORM.RELOAD, () ->
          checkoutService.requestPartial('cart', 'form')
            .then (res) ->
              scope.$broadcast(CHECKOUT_EVENTS.CART.FORM.RERENDER)
              $timeout((() -> element.html($compile(res.data)(scope))), 0)
            .catch (error) ->
              logger.log "Unable to load cart form"
            .finally (() -> onCartFormLoaded())

        element.on "change", "#order-delivery-country", (event) ->
          $rootScope.$emit('cart.form.country.change')
          updateOption { country: angular.element(event.currentTarget).val() }

        element.on "change", "#order-delivery-method", (event) ->
          deliveryOptionId = angular.element(event.currentTarget).val();
          $rootScope.$emit('cart.form.delivery.change', deliveryOptionId)
          updateOption { delivery_option_id: deliveryOptionId, delivery_data: {}}, { triggerItemsValidation: true }

        element.on "change", "#order-payment-method", (event) ->
          updateOption { payment_id: angular.element(event.currentTarget).val() }

        scope.onSfLocationChange = (deliveryData) ->
          updateOption { delivery_data: (deliveryData || {}) }, { rerender: false }

        scope.onPakpoboxLocationChange = (deliveryData) ->
          updateOption { delivery_data: (deliveryData || {}) }, { rerender: false }

        scope.onZeekLocationChange = (deliveryData) ->
          updateOption { delivery_data: (deliveryData || {}) }, { rerender: false }

        scope.onStoreSelected = (deliveryData) ->
          updateOption { delivery_data: (deliveryData || {}) }, { rerender: false, triggerItemsValidation: true }

        validateCartItem = () ->
          cartService.validate()
            .then (data) ->
              scope.$emit(CHECKOUT_EVENTS.CART.ITEMS.CHANGED, { success: true })
            .catch (response) ->
              scope.$emit(CHECKOUT_EVENTS.CART.ITEMS.CHANGED, {
                success: false, cartValidateItem: response
              })

        updateOption = (data, options) ->
          options = {} if !options?
          _.defaults(options, { rerender: true })

          scope.$emit CHECKOUT_EVENTS.CART.FORM.CHANGING if options.rerender
          checkoutService.requestPartial('cart', 'form', data)
            .then (res) ->
              if options.rerender
                scope.$broadcast(CHECKOUT_EVENTS.CART.FORM.RERENDER)
                $timeout((() -> element.html($compile(res.data)(scope))), 0)
              scope.$emit CHECKOUT_EVENTS.CART.FORM.CHANGED, { rerender: options.rerender }
              if options.triggerItemsValidation
                validateCartItem()
            .catch (error) ->
              logger.log "Unable to update option"
              logger.log data
            .finally (() -> onCartFormLoaded())

        checkSLPApplePayAvailable = () ->
          isSupportPaymentMethod('ApplePay').then((response) ->
            isSupportSLPApplePay = response
            hasSLPApplePay = $injector.has('hasSLPApplePay') && $injector.get('hasSLPApplePay')
            $rootScope.supportSLPApplePay = isSupportSLPApplePay && hasSLPApplePay

            if $rootScope.supportSLPApplePay
              scope.$emit("checkout.cart.form.reload")
          )
        checkSLPApplePayAvailable()

        element.on "destroy", (() -> element.off()) # Unbind events
    }
])
